<script>
import Loader from './Loader.vue'

export default {
  components: { Loader },
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>
<template>
  <div>
    <template v-if="loading">
      <slot name="loader">
        <Loader />
      </slot>
    </template>
    <slot v-else></slot>
  </div>
</template>
